module.exports = __webpack_public_path__ + "static/img/9雅冠.9990035.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/9雅冠.jpg
// module id = nbTx
// module chunks = 0